import type { FeedbackDict } from '../en/feedback';

export const feedback: FeedbackDict = {
  title: 'Feedback',
  heading: 'Berätta om din upplevelse',
  description: 'Hjälp oss att förbättra Queri genom att dela med dig av din upplevelse.',
  questions: {
    overall_satisfaction: {
      label: 'Helhetsintryck',
      description: 'Hur nöjd är du med Queri överlag?',
    },
    most_useful_feature: {
      label: 'Mest användbara funktion',
      description: 'Vilken funktion har du mest nytta av?',
    },
    ease_of_use: {
      label: 'Användarvänlighet',
      description: 'Hur lätt är Queri att använda?',
    },
    missing_features: {
      label: 'Saknade funktioner',
      description: 'Finns det några funktioner du önskar att Queri hade?',
    },
    additional_comments: {
      label: 'Övriga kommentarer',
      description: 'Har du någon annan feedback du vill dela med dig av?',
    },
  },
  options: {
    'Document Chat': 'Dokumentchatt',
    'Document Review': 'Dokumentgranskning',
    Playbooks: 'Playbooks',
    'Knowledge Database': 'Kunskapsdatabas',
    'Meeting Assistant': 'Mötesassistent',
  },
  responsePlaceholder: 'Skriv ditt svar …',
  selectPlaceholder: 'Välj ett alternativ',
  submit: 'Skicka feedback',
  submitting: 'Skickar …',
  missingRequired: (fields: string) => `Fyll i: ${fields}`,
  subscriptionExtendedToast: 'Ditt abonnemang har förlängts med 1 månad!',
  thanksToast: 'Tack för din feedback!',
  submitFailed: 'Det gick inte att skicka feedbacken',
  thankYou: 'Tack!',
  submittedExtended:
    'Din feedback har skickats och ditt abonnemang har förlängts med 1 månad!',
  submitted: 'Din feedback har skickats. Vi uppskattar att du tog dig tid.',
  submitAnother: 'Skicka ett till svar',
};
